import { AuthError, signInWithEmailAndPassword } from 'firebase/auth';
import { channelLogin } from 'shared/services/backend-api/helpers/auth';
import { getLoggableError, getRollbar } from 'shared/services/error-tracking';
import { LoginErrorTypes } from 'shared/types/login-form';

import { getUser } from './get-user';
import { getAuthentication } from './helpers';
import { setUserCountry } from './set-user-country';

export const signInUser = async (email: string, password: string) => {
  const auth = await getAuthentication();

  try {
    await signInWithEmailAndPassword(auth, email, password);
    const user = await getUser();

    try {
      if (!user?.settings?.country) {
        await setUserCountry();
      }
    } catch (e) {
      // do nothing, eventually send error to sentry or something like that
    }

    // log other tabs in as well
    channelLogin();

    return user;
  } catch (e) {
    if (
      [
        'auth/user-not-found',
        'auth/invalid-login-credentials',
        'auth/invalid-credential',
        'auth/wrong-password',
      ].includes((e as AuthError)?.code)
    ) {
      throw LoginErrorTypes.WrongCombination;
    }

    getRollbar().error(
      'Firebase Sign-in Error: failed to login',
      getLoggableError(e),
    );
    throw LoginErrorTypes.Unknown;
  }
};
